/* eslint-disable no-undef */
const ENVIRONMENT_CONFIG = {
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL
}

Object.freeze(ENVIRONMENT_CONFIG);
export default ENVIRONMENT_CONFIG;
